import axios from 'axios'
import store from '@/store'
import router from '@/router'
// import apiAuth from '@/apis/auth'
import { getToken, setToken, getRefreshToken } from '@/utils/auth'

const BASE_URL = 'api'

// create an axios instance
const service = axios.create({
  baseURL: `${process.env.VUE_APP_CORE_BACKEND}/${BASE_URL}`, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 3000000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  async config => {
    const token = getToken()
    if (token) {
      const refresh_token = getRefreshToken()

      // refresh token not found
      if (!refresh_token || refresh_token === 'undefined') {
        await forceFrontendLogout('Force login')

        return
      }

      // // refresh token expired
      // const refreshJwtPayload = JSON.parse(
      //   window.atob(refresh_token.split('.')[1])
      // )
      // if (refreshJwtPayload.exp * 1000 < Date.now()) {
      //   await forceFrontendLogout('Session timeout')

      //   return
      // }

      // if (config.url !== '/health') {
      //   const jwtPayload = JSON.parse(window.atob(token.split('.')[1]))
      //   // if expire
      //   if (jwtPayload.exp * 1000 < Date.now()) {
      //     try {
      //       const responseRefresh = await axios.post(
      //         `${process.env.VUE_APP_CORE_BACKEND}/api/auth/refresh`,
      //         { refresh_token },
      //         {
      //           headers: {
      //             Authorization: `Bearer ${refresh_token}`
      //           }
      //         }
      //       )
      //       setToken(responseRefresh.data.data.token)
      //     } catch (e) {
      //       // Refresh token also expire
      //       return await forceLogout(e.response.data.message)
      //     }
      //   }
      // }

      config.headers.Authorization = `Bearer ${getToken()}`
    }
    return config
  },
  error => {
    // do something with request error
    //console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  async error => {
    let errorData = ''

    try {
      const user = store.getters['auth/user']
      const httpStatus = error.response.status
      errorData = error.response.data

      if (httpStatus === 400) {
        throw new Error(error.response.data.message)
      } else if (httpStatus === 401) {
        if (user.auth && error.config.url !== '/health') {
          try {
            const refresh_token = getRefreshToken()
            // refresh token not found
            if (!refresh_token || refresh_token === 'undefined') {
              return await forceFrontendLogout('Force login')
            }

            const refreshJwtPayload = JSON.parse(
              window.atob(refresh_token.split('.')[1])
            )

            if (refreshJwtPayload.exp * 1000 < Date.now()) {
              return await forceLogout('Session timeout')
            } else {
              const responseRefresh = await axios.post(
                `${process.env.VUE_APP_CORE_BACKEND}/api/auth/refresh`,
                { refresh_token },
                {
                  headers: {
                    Authorization: `Bearer ${refresh_token}`
                  }
                }
              )

              if (
                responseRefresh &&
                responseRefresh.data &&
                responseRefresh.data.data &&
                responseRefresh.data.data.token
              ) {
                setToken(responseRefresh.data.data.token)

                error.config.__isRetry = true
                error.config.headers.Authorization = `Bearer ${getToken()}`
                return service.request(error.config)
              } else {
                return await forceLogout('Refresh token is invalid')
              }
            }
          } catch (e) {
            // Refresh token also expire
            return await forceLogout(e.response.data.message)
          }
        }
      } else if (httpStatus === 403) {
        router.replace({ path: '/404' })
      } else if (httpStatus === 405) {
        return await forceFrontendLogout(
          'You have been logged out. This account has logged in from another machine.'
        )
      } else throw new Error(error.response.data.message)
      // else if (httpStatus === 500) {
      //   // Backend error rediect to login page
      //   return await forceLogout('Unknown error')
      // } else if (httpStatus === 504) {
      //   throw new Error(error.response.data.message)
      // }
    } catch (e) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        throw new Error(error.response.data.message)
      } else if (
        error.request &&
        error.request.responseType === 'blob' &&
        error.response.data instanceof Blob &&
        error.response.data.type &&
        error.response.data.type.toLowerCase().indexOf('json') != -1
      ) {
        const errormsg = JSON.parse(await error.response.data.text())
        throw new Error(errormsg.message)
      } else {
        throw new Error(error)
      }
    }

    return errorData
  }
)

async function forceLogout(message) {
  try {
    await store.dispatch('auth/logout')
    router.replace({
      // path: '/login',
      name: 'Login',
      params: { error: message }
    })
  } catch {}
}

async function forceFrontendLogout(message) {
  try {
    await store.dispatch('auth/frontendLogout')
    router.replace({
      name: 'Login',
      params: { error: message }
    })
  } catch {}
}

export default service
